// extracted by mini-css-extract-plugin
export var adjacentSlide = "_qb-9";
export var arrowButtonContainer = "_qb-5";
export var arrowButtonIcon = "_qb-6";
export var carouselArrowButton = "_qb-2";
export var carouselElementContainer = "_qb-1";
export var currentSlide = "_qb-8";
export var left = "_qb-3";
export var otherSlide = "_qb-a";
export var productCarouselContainer = "_qb-0";
export var right = "_qb-4";
export var sliderOverflow = "_qb-7";